// Components==============
import Dropdown from 'components/UI/Dropdown/Dropdown';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { GlobalTrainingUserContext } from 'utilities/GlobalContext/GlobalTrainingUser';
import { sortOnName } from 'utilities/sortOnName';
import { TrainingDetailsContext } from '../../TrainingDetails';
import './Top.module.scss';
// =========================

export default function Top() {
  const { setTrainingUser, trainingUser } = useContext(
    GlobalTrainingUserContext
  );
  const { subscribers, training } = useContext(TrainingDetailsContext);

  const translate = useTranslate();
  const userId = useRedux((state) => state.authentication?.user?.id);

  const currentSub = subscribers?.find((sub) => sub?.user_id === trainingUser);

  const userName =
    trainingUser === userId
      ? (translate('course.terms.my-course') as string)
      : `${currentSub?.user.first_name} ${currentSub?.user.last_name}`;

  const [selectedSub, setSelectedSub] = useState(userName);

  useEffect(() => setSelectedSub(userName), [trainingUser]);

  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount((prev) => prev + 1);
    if (count === 0) return;

    if (selectedSub === translate('course.terms.my-course') && userId)
      return setTrainingUser(userId);

    return setTrainingUser(
      subscribers?.find(
        (sub) =>
          `${sub?.user.first_name} ${sub?.user.last_name}` === selectedSub
      )?.user_id || 0
    );
  }, [selectedSub]);

  const selectorCondition =
    training?.owner_id === userId && training?.is_published;

  const initialOptions = useMemo(
    () => [
      translate('course.terms.my-course') as string,
      ...sortOnName(
        subscribers?.map(
          (sub) => `${sub?.user.first_name} ${sub?.user.last_name}`
        ) || []
      ),
    ],
    [subscribers?.length]
  );

  return (
    <>
      {!!(selectorCondition && !!subscribers?.length) && (
        <div styleName="wrapper">
          <div>
            <p styleName="students">
              {subscribers.length > 1
                ? translate('general.terms.students')
                : translate('general.terms.student')}
              : {subscribers.length}
            </p>
            <div styleName="dropdown">
              <Dropdown
                initialOptions={initialOptions}
                initialText={selectedSub}
                selectedItem={selectedSub}
                setSelectedItem={setSelectedSub}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
